import React, { useState } from "react";
import { Container, TextField, Button, Typography, Box, InputAdornment } from "@mui/material";
import { PermIdentity, Lock, Visibility, VisibilityOff } from "@mui/icons-material";
import image from './assets/MyImg/enzo.png';
import { useNavigate } from "react-router-dom";
import axios from "axios"; // Add this import for making API requests

const AdminLogin = ({ onLogin }) => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();

  const togglePasswordVisibility = () => setShowPassword(!showPassword);

  const handleLogin = async () => {
    try {
      const response = await axios.post("https://enzo-matr.onrender.com/api/admin/login", {
        username: username.trim(), // Trim whitespace to avoid issues
        password,
      });

      if (response.status === 200) {
        onLogin(); // Notify App.js that admin login was successful
        navigate("/"); // Navigate to the admin page
      }
    } catch (error) {
      alert(error.response?.data?.message || "Invalid username or password");
    }
  };

  return (
    <Container
      maxWidth="xl"
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "100vw",
        height: "100vh",
        background: "white",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          width: "480px",
          height: "450px",
          marginLeft: "10px",
          boxShadow: 7,
          borderRadius: "20px",
          overflow: "hidden",
          background: "white",
        }}
      >
        {/* Left Section (Login Box) */}
        <Box
          sx={{
            flex: 1,
            width: "400px",
            backgroundColor: "#00C0C0",
            padding: "70px",
            color: "white",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            borderTopLeftRadius: "20px",
            borderBottomLeftRadius: "20px",
          }}
        >
          <Typography
            variant="h6"
            sx={{
              fontFamily: "Caladea, serif",
              fontWeight: "bold",
              fontSize: 25,
              backgroundColor: "white",
              color: "black",
              borderRadius: 3,
              width: "180px",
              padding: 1,
              textAlign: "center",
            }}
          >
            ADMIN
          </Typography>
          <Typography
            variant="h5"
            sx={{
              fontFamily: "Caladea, serif",
              textAlign: "center",
              mt: 3,
              fontWeight: "bold",
            }}
          >
            Login to Your Account
          </Typography>
          <Typography
            variant="body2"
            sx={{
              fontFamily: "Caladea, serif",
              textAlign: "center",
              mt: 1,
            }}
          >
            Login Using
          </Typography>
          <Box
            component="form"
            sx={{ mt: 3, width: "80%" }}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                e.preventDefault(); // Prevent default form submit
                handleLogin();
              }
            }}
          >
            <TextField
              fullWidth
              placeholder="Username or Email" // Updated placeholder text
              variant="outlined"
              size="small"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              sx={{
                backgroundColor: "white",
                borderRadius: "5px",
                fontFamily: "Caladea, serif",
              }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <PermIdentity />
                  </InputAdornment>
                ),
                sx: {
                  "& input::placeholder": {
                    color: "black", // Set placeholder color to black
                    opacity: 1,
                    fontFamily: "Caladea, serif",
                  },
                },
              }}
            />
            <TextField
              fullWidth
              margin="normal"
              placeholder="Password"
              type={showPassword ? "text" : "password"}
              variant="outlined"
              size="small"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              sx={{
                backgroundColor: "white",
                borderRadius: "5px",
                fontFamily: "Caladea, serif",
              }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Lock />
                  </InputAdornment>
                ),
                sx: {
                  "& input::placeholder": {
                    color: "black", // Set placeholder color to black
                    opacity: 1, // Ensure visibility
                    fontFamily: "Caladea, serif",
                  },
                },
                endAdornment: (
                  <InputAdornment position="end">
                    {showPassword ? (
                      <VisibilityOff
                        onClick={togglePasswordVisibility}
                        sx={{ cursor: "pointer", "&:hover": { color: "#FFA500" } }}
                      />
                    ) : (
                      <Visibility
                        onClick={togglePasswordVisibility}
                        sx={{ cursor: "pointer", "&:hover": { color: "#FFA500" } }}
                      />
                    )}
                  </InputAdornment>
                ),
              }}
            />

            <Box sx={{ display: "flex", justifyContent: "center" }}>
              <Button
                variant="h5"
                sx={{
                  mt: 2,
                  textTransform: "None",
                  bgcolor: "black",
                  width: "200px",
                  borderRadius: "10px",
                  fontWeight: "bold",
                  padding: "9px",
                }}
                onClick={handleLogin}
              >
                Login
              </Button>
            </Box>
            <Typography
              variant="body2"
              sx={{
                fontFamily: "Montserrat, sans-serif",
                textAlign: "center",
                mt: 8,
                color: "white",
                position: "relative",
                top: "15px",
              }}
            >
              Forgot Your Password?
            </Typography>
          </Box>
        </Box>
      </Box>
       {/* Right Section (Signup Prompt) */}
       <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          width: "400px",
          height: "450px",
          position: "relative",
          right: "30px",
          boxShadow: 15,   
          borderRadius: "20px",
          overflow: "hidden",
         }}
      >
      <Box
      sx={{
        flex: 1,
        backgroundColor: "white",
        padding: "40px",
        textAlign: "center",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "flex-start",
        borderTopLeftRadius: "20px",
        borderBottomLeftRadius: "20px"
      }}
    >
      <img 
      src={image} 
      alt="Enzo Logo" 
      style={{ width: "350px", 
      height: "160px",
      position: "relative",
      right: "30px",
      marginTop: "-15px",
      }} />

      <Typography variant="h4" sx={{  fontFamily: "Caladea, sans-serif",mt: 4, fontWeight: "bold",color:"black" }}>
         NEW HERE?
      </Typography>
      <Typography variant="body2" sx={{ fontFamily: "Montserrat, sans-serif",mt: 1,color:"black",fontWeight:"bold" }}>
        Sign Up and create your <br/>
            own Account!
      </Typography>
      <Button
        variant="h4"
        sx={{
          mt: 3,
          textTransform:"none",
          bgcolor: "#FFA500",
          borderRadius: "10px",
          fontWeight: "bold",
          padding: "9px",
          fontFamily: "Montserrat, sans-serif",
          width : "200px",
          color:"white"
        }}
        onClick={() => navigate("/login-signup")}
      >
       Sign Up 
        </Button>
      </Box>
    </Box>
    </Container>
  );
};

export default AdminLogin;
